import { useEffect, useState } from 'react';
import BlogContent from './BlogContent'
import BlogOther from './BlogOther'
import { useNavigate, useParams } from 'react-router-dom';
import { BaseUrl } from '../../helper/BaseUrl';
import axios from 'axios';
import GlobalFaq from '../../component/GlobalFaq';

export default function BlogDetail({ initialData }) {
    const navigate = useNavigate();
    const { slug } = useParams();
    const [data, setData] = useState(initialData?.blog || []);

    useEffect(() => {
      if (initialData?.blog) {
        return;
      }

      const fetchData = async () => {
        try {
          const response = await axios.get(`${BaseUrl}/api/blog/${slug}`);
          setData(response.data.data);
          if(response.data.success == false){
            navigate("/404")
          }
        } catch (error) {
            navigate("/404")
          console.error("Error fetching blog data:", error);
        }
      };
  
      fetchData();
    }, [slug, initialData?.blog]);

  return (
    <>
     <BlogContent data={data}/> 
     <GlobalFaq/>
     <BlogOther initialBlogs={initialData?.blogs} />
    </>
  )
}
